import { render, staticRenderFns } from "./MigradorMembresias.vue?vue&type=template&id=673e97f6&scoped=true"
import script from "./MigradorMembresias.vue?vue&type=script&lang=js"
export * from "./MigradorMembresias.vue?vue&type=script&lang=js"
import style0 from "./MigradorMembresias.vue?vue&type=style&index=0&id=673e97f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e97f6",
  null
  
)

export default component.exports